import { MIXPANEL } from '@/clients'

const postMixpanelEvent = async payload => {
  return MIXPANEL.post('track', payload)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(console.log(error)))
}

export { postMixpanelEvent }
